import React from 'react';
import { browserHistory } from 'react-router';

import { ErrorBoundaryMessage } from '@lumahealthhq/ui-common';

import ErrorBoundary from '../ErrorBoundary';

interface ErrorBoundaryAppProps {}

const ErrorBoundaryApp: React.FC<ErrorBoundaryAppProps> = (props) => (
  <ErrorBoundary
    fallbackRender={({ resetErrorBoundary }) => (
      <ErrorBoundaryMessage
        onClick={() => {
          resetErrorBoundary();
          browserHistory.push('/');
        }}
      />
    )}
    {...props}
  />
);

export default ErrorBoundaryApp;
